"use client";

import React from "react";
import { Textarea } from "@/components/ui/textarea";
import { useTranslation } from "react-i18next";
import { usePromptField } from "../PromptFieldContext";

interface PromptFieldReadonlyProps {
  label?: string;
  helperText?: string;
  helperTextKey?: string;
  placeholder?: string;
  minRows?: number;
}

const PromptFieldReadonly: React.FC<PromptFieldReadonlyProps> = ({
  label,
  helperText,
  helperTextKey,
  placeholder,
  minRows = 4,
}) => {
  const { prompt } = usePromptField();
  const { t } = useTranslation(["pages", "components"]);

  const resolvedPlaceholder =
    placeholder ??
    (t("pages:create.promptDock.readonlyPlaceholder", {
      defaultValue: "请在底部 Prompt Dock 中输入/编辑提示词",
    }) as string);

  const resolvedHelper =
    helperText ??
    (helperTextKey
      ? (t(helperTextKey, { defaultValue: "" }) as string)
      : (t("pages:create.promptDock.readonlyHelper", {
          defaultValue: "提示词现由 Prompt Dock 统一管理，此处仅供查看。",
        }) as string));

  return (
    <div className="flex flex-col gap-1">
      {label ? <div className="text-sm text-foreground/90 font-medium">{label}</div> : null}
      <Textarea value={prompt} disabled placeholder={resolvedPlaceholder as string} className="min-h-16" rows={minRows} />
      {resolvedHelper ? (
        <p className="text-muted-foreground text-xs">{resolvedHelper}</p>
      ) : null}
    </div>
  );
};

export default PromptFieldReadonly;
